import {
    apiRequest,
    pensiunPegawaiCreate,
    masterEmployee,
    masterType,
    pensiunPegawaiGetEmployee
} from "../../../../../services/adapters/kepegawaian/pensiunpegawaiService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", pensiunPegawaiCreate, {
            body: query
        }, true)
    }

    fetchEmployee = async (query) => {
        return await apiRequest("get", masterEmployee, {
            params: query
        }, true)
    }

    fetchType = async (query) => {
        return await apiRequest("get", masterType, {
            params: query
        }, true)
    }

    fetchEmployeeSelf = async (query) => {
        return await apiRequest("get", pensiunPegawaiGetEmployee, {
            params: query
        }, true)
    }

}

export default CreateRepository